import { createPinia } from 'pinia';
import { ExtendApp } from 'src/types/interface';

export const store = createPinia();

export function setupStore(app: ExtendApp<Element>) {
    app.use(store);
}

export default { store };
